module.exports = __webpack_public_path__ + "assets/img/挂牌项目.7e7a429a.png";